/* Great Lakes Lavender Farm — Field Notes recipe tools · v2
   Ingredient checklist, servings scaler, shopping list, printable 4x6 recipe cards.
   Also exposes window.GLLFRecipes so other pages (gift print sheets, market table cards)
   can render the same cards. Reads the page only. Nothing is saved to Shopify. */
(function () {
  'use strict';
  if (window.GLLFRecipes) return;

  var QR_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/qrcode-generator/1.4.4/qrcode.min.js';
  var SPRIG = '<svg viewBox="0 0 50 70" aria-hidden="true"><path d="M25 68C25 46 25 28 26 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><g fill="currentColor"><ellipse cx="26" cy="8" rx="3" ry="4.5"/><ellipse cx="21.5" cy="15" rx="3" ry="4.2" transform="rotate(-25 21.5 15)"/><ellipse cx="30.5" cy="15" rx="3" ry="4.2" transform="rotate(25 30.5 15)"/><ellipse cx="21" cy="23" rx="3" ry="4.2" transform="rotate(-25 21 23)"/><ellipse cx="31" cy="23" rx="3" ry="4.2" transform="rotate(25 31 23)"/><ellipse cx="21" cy="31" rx="2.8" ry="4" transform="rotate(-25 21 31)"/><ellipse cx="30.5" cy="31" rx="2.8" ry="4" transform="rotate(25 30.5 31)"/></g><path d="M25 52c-6-2-10-7-11-13 6 1 10 5 11 13Z" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }

  /* ---------- Quantity math for the servings scaler ---------- */
  var NUM = /(\d+\s+\d+\/\d+|\d+\/\d+|\d+(?:\.\d+)?)/g;
  function toNum(s) {
    s = s.trim();
    var m = s.match(/^(\d+)\s+(\d+)\/(\d+)$/); if (m) return +m[1] + m[2] / m[3];
    m = s.match(/^(\d+)\/(\d+)$/); if (m) return m[1] / m[2];
    return parseFloat(s);
  }
  function toFrac(n) {
    var whole = Math.floor(n + 1e-9), rest = n - whole, best = '', diff = 1;
    [[0, ''], [1 / 8, '1/8'], [1 / 4, '1/4'], [1 / 3, '1/3'], [3 / 8, '3/8'], [1 / 2, '1/2'], [5 / 8, '5/8'], [2 / 3, '2/3'], [3 / 4, '3/4'], [7 / 8, '7/8'], [1, '']].forEach(function (f) {
      var d = Math.abs(rest - f[0]); if (d < diff) { diff = d; best = f[1]; if (f[0] === 1) whole += 0; }
    });
    if (Math.abs(rest - 1) < diff) { whole += 1; best = ''; }
    if (!whole && !best) return '1/8';
    return whole && best ? whole + ' ' + best : whole ? String(whole) : best;
  }
  var PLURAL = { bag: 'bags', jar: 'jars', loaf: 'loaves', pouch: 'pouches', batch: 'batches', pinch: 'pinches', serving: 'servings', drop: 'drops', lemon: 'lemons', lime: 'limes', orange: 'oranges', egg: 'eggs', pie: 'pies', stick: 'sticks' };
  function scaleQty(orig, factor) {
    if (factor === 1) return orig;
    var first = null;
    var out = orig.replace(NUM, function (m) { var v = toNum(m) * factor; if (first === null) first = v; return toFrac(v); });
    if (first !== null && first > 1) out = out.replace(/\b(bag|jar|loaf|pouch|batch|pinch|serving|drop|lemon|lime|orange|egg|pie|stick)\b(?!s)/, function (w) { return PLURAL[w] || w; });
    return out;
  }

  /* ---------- Ingredient checklist (remembered on this device) ---------- */
  function ingredientItems(recipe) { return $$('.gllf-recipe__ingredients li', recipe); }
  function initChecklist(recipe) {
    var key = 'gllf-rx-checked:' + location.pathname;
    var saved = store(key) || [];
    ingredientItems(recipe).forEach(function (li, i) {
      li.setAttribute('role', 'checkbox');
      li.setAttribute('tabindex', '0');
      var set = function (on) { li.classList.toggle('is-checked', on); li.setAttribute('aria-checked', on ? 'true' : 'false'); };
      set(saved.indexOf(i) > -1);
      var toggle = function (e) {
        if (e.target.closest('a')) return;
        if (e.type === 'keydown' && e.key !== ' ' && e.key !== 'Enter') return;
        e.preventDefault();
        set(!li.classList.contains('is-checked'));
        store(key, ingredientItems(recipe).reduce(function (acc, x, j) { if (x.classList.contains('is-checked')) acc.push(j); return acc; }, []));
      };
      li.addEventListener('click', toggle);
      li.addEventListener('keydown', toggle);
    });
  }

  /* ---------- Servings scaler ---------- */
  function initScaler(recipe, bar) {
    var wrap = $('[data-rx-scale]', bar); if (!wrap) return;
    var qtys = $$('.gllf-recipe__qty', recipe);
    var yieldFact = $('.gllf-recipe__facts span', recipe);
    qtys.forEach(function (q) { q.setAttribute('data-orig', q.textContent); });
    if (yieldFact) yieldFact.setAttribute('data-orig', yieldFact.textContent);
    function apply(f) {
      qtys.forEach(function (q) { q.textContent = scaleQty(q.getAttribute('data-orig'), f); });
      if (yieldFact) yieldFact.textContent = f === 1 ? yieldFact.getAttribute('data-orig') : scaleQty(yieldFact.getAttribute('data-orig'), f) + ' (' + (f === 0.5 ? '½' : f) + '×)';
      $$('button', wrap).forEach(function (b) { b.setAttribute('aria-pressed', +b.value === f ? 'true' : 'false'); });
      var st = $('[data-rx-scale-status]', bar); if (st) st.textContent = f === 1 ? 'Original amounts' : 'Amounts scaled ' + (f === 0.5 ? 'to half' : f + ' times');
    }
    wrap.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) apply(+b.value); });
  }

  /* ---------- Shopping list ---------- */
  function shoppingList(recipe, title, url) {
    var farm = [], pantry = [];
    ingredientItems(recipe).forEach(function (li) {
      if (li.classList.contains('is-checked')) return;
      (li.querySelector('a[href*="/products/"]') ? farm : pantry).push(txt(li));
    });
    var lines = ['Shopping list: ' + title, ''];
    if (farm.length) { lines.push('From Great Lakes Lavender Farm (farm stand, markets & events):'); farm.forEach(function (x) { lines.push('[ ] ' + x); }); lines.push(''); }
    if (pantry.length) { lines.push('From the grocery store or pantry:'); pantry.forEach(function (x) { lines.push('[ ] ' + x); }); lines.push(''); }
    lines.push('Recipe: ' + url);
    return { farm: farm, pantry: pantry, text: lines.join('\n') };
  }
  function initShoppingList(recipe, bar, root) {
    var btn = $('[data-rx-list]', bar), dlg = $('[data-rx-list-dialog]', root); if (!btn || !dlg) return;
    var title = root.getAttribute('data-title') || txt($('.gllf-fn__title')), url = root.getAttribute('data-url') || location.href;
    function render() {
      var l = shoppingList(recipe, title, url);
      $('[data-rx-list-farm]', dlg).innerHTML = l.farm.length ? l.farm.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') : '<li class="is-empty">Nothing left to pick up from the farm.</li>';
      $('[data-rx-list-pantry]', dlg).innerHTML = l.pantry.length ? l.pantry.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') : '<li class="is-empty">You have everything else.</li>';
      return l;
    }
    btn.addEventListener('click', function () { render(); if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) { if (e.target === dlg) dlg.close(); return; }
      var status = $('[data-rx-list-status]', dlg), l = render();
      if (b.hasAttribute('data-rx-list-close')) dlg.close();
      if (b.hasAttribute('data-rx-list-copy')) {
        var done = function () { status.textContent = 'Copied. Paste it into your notes or a text.'; };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(l.text).then(done, function () { status.textContent = 'Copy did not work here. Select the list and copy it.'; });
        else status.textContent = 'Select the list and copy it.';
      }
      if (b.hasAttribute('data-rx-list-share')) {
        if (navigator.share) navigator.share({ title: 'Shopping list: ' + title, text: l.text }).catch(function () {});
        else status.textContent = 'Sharing is not available in this browser. Use Copy instead.';
      }
      if (b.hasAttribute('data-rx-list-print')) printList(l, title);
    });
  }
  function printList(l, title) {
    var box = document.createElement('div'); box.className = 'gllf-card-print gllf-list-print';
    box.innerHTML = '<section class="gllf-list-sheet"><h1>' + esc(title) + '</h1><p class="gllf-list-sheet__k">Shopping list</p>' +
      (l.farm.length ? '<h2>From Great Lakes Lavender Farm</h2><p>Farm stand, markets &amp; events</p><ul>' + l.farm.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
      (l.pantry.length ? '<h2>Grocery store or pantry</h2><ul>' + l.pantry.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') + '</section>';
    document.body.appendChild(box);
    var page = document.createElement('style'); page.textContent = '@page{size:letter;margin:.6in}'; document.head.appendChild(page);
    document.body.classList.add('gllf-printing-card');
    var done = function () { document.body.classList.remove('gllf-printing-card'); box.remove(); page.remove(); window.removeEventListener('afterprint', done); };
    window.addEventListener('afterprint', done);
    setTimeout(function () { window.print(); setTimeout(done, 1500); }, 50);
  }

  /* ---------- Printable 4x6 card (shared) ---------- */
  var qrPromise = null;
  function loadQr(src) {
    if (window.qrcode) return Promise.resolve();
    if (!qrPromise) {
      qrPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script'); s.src = src || QR_SRC; s.onload = resolve; s.onerror = reject; document.head.appendChild(s);
      });
    }
    return qrPromise;
  }
  function qrSvg(url) {
    try { var q = window.qrcode(0, 'M'); q.addData(url); q.make(); return q.createSvgTag(2, 0); } catch (e) { return ''; }
  }
  function cardHtml(d, qr) {
    var ing = (d.ingredients || []).map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('');
    var steps = (d.steps || []).map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('');
    var foot = '<div class="gllf-card__foot"><span>' + esc(d.shop || 'Great Lakes Lavender Farm') + '</span><span>' + esc(d.domain || location.host) + '</span></div>';
    return '' +
      '<section class="gllf-card gllf-card--front"><div class="gllf-card__frame"></div><div class="gllf-card__in">' +
        '<div class="gllf-card__side">' +
          (d.logo ? '<img class="gllf-card__logo" src="' + esc(d.logo) + '" alt="">' : '') +
          '<p class="gllf-card__eyebrow">' + esc(d.eyebrow || 'Lavender Field Notes') + '</p>' +
          '<h1 class="gllf-card__title">' + esc(d.title) + '</h1>' +
          '<p class="gllf-card__facts">' + (d.facts || []).map(esc).join('<br>') + '</p>' +
          (qr ? '<div class="gllf-card__qr">' + qr + '<span>Scan for the full Field Note, tips &amp; variations</span></div>' : '') +
        '</div>' +
        '<div class="gllf-card__main" data-fit><h2 class="gllf-card__h">Ingredients</h2><ul class="gllf-card__list gllf-card__list--ing' + ((d.ingredients || []).length > 8 ? ' is-two' : '') + '">' + ing + '</ul></div>' +
      '</div><span class="gllf-card__sprig gllf-card__sprig--front">' + SPRIG + '</span>' + foot + '</section>' +
      '<section class="gllf-card gllf-card--back"><div class="gllf-card__frame"></div><span class="gllf-card__sprig">' + SPRIG + '</span><div class="gllf-card__in">' +
        '<div class="gllf-card__main" data-fit><h2 class="gllf-card__h">Directions</h2><ol class="gllf-card__list gllf-card__list--steps">' + steps + '</ol>' +
        (d.tip ? '<p class="gllf-card__tip"><strong>Farm kitchen tip:</strong> ' + esc(d.tip) + '</p>' : '') +
        '</div>' +
      '</div>' + foot + '</section>';
  }
  function fit(container) {
    $$('[data-fit]', container).forEach(function (box) {
      var size = 10.5;
      box.style.setProperty('--card-fs', size + 'pt');
      while (box.scrollHeight > box.clientHeight + 1 && size > 6) { size -= 0.25; box.style.setProperty('--card-fs', size + 'pt'); }
    });
  }
  function whenImages(container) {
    return Promise.all($$('img', container).map(function (img) { return img.complete ? null : new Promise(function (r) { img.onload = img.onerror = r; }); }));
  }
  /* Renders cards into `container` (visible or offscreen) and resolves when fonts, images and fitting are done. */
  function renderCards(container, d, opts) {
    opts = opts || {};
    return loadQr(opts.qrSrc).catch(function () {}).then(function () {
      container.innerHTML = cardHtml(d, window.qrcode && d.url ? qrSvg(d.url) : '');
      var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
      return Promise.all([fonts, whenImages(container)]).then(function () { fit(container); return container; });
    });
  }
  /* Loads one recipe's card data from its Field Note (article alternate template "recipe-json"). */
  function fetchRecipe(url) {
    var u = url.split('#')[0].split('?')[0];
    return fetch(u + '?view=recipe-json', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('recipe'); return r.json(); });
  }

  var busy = false;
  function printCards(d, mode, qrSrc) {
    if (busy) return; busy = true;
    var box = document.createElement('div');
    box.className = 'gllf-card-print' + (mode === 'letter' ? ' gllf-card-print--letter' : '');
    box.style.cssText = 'display:block;position:absolute;left:-9999px;top:0';
    document.body.appendChild(box);
    var page = document.createElement('style');
    page.textContent = mode === 'letter' ? '@page{size:letter;margin:0}' : '@page{size:6in 4in;margin:0}';
    document.head.appendChild(page);
    return renderCards(box, d, { qrSrc: qrSrc }).then(function () {
      box.style.cssText = '';
      document.body.classList.add('gllf-printing-card');
      var done = function () {
        document.body.classList.remove('gllf-printing-card');
        box.remove(); page.remove(); busy = false;
        window.removeEventListener('afterprint', done);
      };
      window.addEventListener('afterprint', done);
      setTimeout(function () { window.print(); setTimeout(function () { if (busy) done(); }, 1500); }, 50);
    }).catch(function () { busy = false; box.remove(); page.remove(); });
  }
  function collect(root) {
    var body = $('[data-gllf-note-body]') || document, recipe = $('.gllf-recipe', body);
    if (!recipe) return null;
    return {
      title: root.getAttribute('data-title') || txt($('.gllf-fn__title')),
      eyebrow: root.getAttribute('data-eyebrow') || 'Lavender Field Notes',
      facts: $$('.gllf-recipe__facts span', recipe).map(txt),
      ingredients: ingredientItems(recipe).map(txt),
      steps: $$('.gllf-recipe__steps li', recipe).map(txt),
      tip: txt($('.gllf-recipe__tip p', recipe)),
      url: root.getAttribute('data-url') || location.origin + location.pathname,
      logo: root.getAttribute('data-logo') || '',
      shop: root.getAttribute('data-shop') || 'Great Lakes Lavender Farm',
      domain: root.getAttribute('data-domain') || location.host
    };
  }

  /* ---------- Wire up a recipe article ---------- */
  function initArticle(root) {
    var body = $('[data-gllf-note-body]'), recipe = body && $('.gllf-recipe', body);
    if (!recipe) return;
    var bar = $('[data-rx-bar]', root), shop = $('[data-rx-shop]', root), made = $('[data-rx-after]', root);
    if (bar) { bar.hidden = false; recipe.insertBefore(bar, recipe.firstChild); }
    if (shop) recipe.parentNode.insertBefore(shop, recipe.nextSibling);
    if (made && shop) shop.parentNode.insertBefore(made, shop.nextSibling);
    initChecklist(recipe);
    if (bar) { initScaler(recipe, bar); initShoppingList(recipe, bar, root); }

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#print-card"], [data-rx-print]');
      if (!a) return;
      e.preventDefault();
      printCards(collect(root), a.getAttribute('data-rx-print') || 'card', root.getAttribute('data-qr-src'));
    });

    var params = new URLSearchParams(location.search);
    if (params.get('print') === 'card' || location.hash === '#print-card') {
      recipe.scrollIntoView({ block: 'start' });
      setTimeout(function () { printCards(collect(root), params.get('paper') === 'letter' ? 'letter' : 'card', root.getAttribute('data-qr-src')); }, 600);
    }
  }

  window.GLLFRecipes = { QR_SRC: QR_SRC, cardHtml: cardHtml, fit: fit, loadQr: loadQr, qrSvg: qrSvg, renderCards: renderCards, fetchRecipe: fetchRecipe, printCards: printCards, scaleQty: scaleQty, esc: esc };

  function boot() { $$('[data-gllf-rx]:not([data-rx-ready])').forEach(function (el) { el.setAttribute('data-rx-ready', ''); initArticle(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
